import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Loader from 'components/loader'
import Dialoguemodal from 'components/dialoguemodal'
import ConfirmationModal from 'components/confimation-modal'
import SearchList from 'components/search-list'
import { categoriesApi } from '../restaurant.api'
import { CategoriesProvider, useCategories } from './categories.context'
import CategoryForm from './category-form'

function CategoryRow({ category, onEdit, onDelete }) {
  return (
    <div className='tw-flex tw-items-center tw-gap-4 tw-py-3 tw-px-3 tw-rounded-[8px] tw-border tw-border-[#E7DFD9] tw-bg-white'>
      <span className='tw-text-2xl tw-w-8 tw-text-center'>
        {category.icon || '🍽️'}
      </span>
      {category.image && (
        <img
          src={category.image}
          alt=''
          className='tw-h-10 tw-w-10 tw-rounded-[8px] tw-object-cover'
        />
      )}
      <div className='tw-flex-1 tw-overflow-hidden'>
        <p className='tw-font-semibold tw-text-[15px] tw-truncate'>
          {category.name}
        </p>
        <p className='tw-text-xs tw-text-gray-500 tw-capitalize'>
          {category.count || 0} products · {category.status}
        </p>
      </div>
      <button
        type='button'
        onClick={() => onEdit(category)}
        className='tw-text-[12px] tw-px-[10px] tw-py-[4px] tw-rounded-[5px] tw-border tw-border-gray-300 tw-text-gray-600'
      >
        Edit
      </button>
      <button
        type='button'
        onClick={() => onDelete(category)}
        className='tw-text-[12px] tw-px-[10px] tw-py-[4px] tw-rounded-[5px] tw-border tw-border-[#FBE9E7] tw-text-[#C0392B]'
      >
        Delete
      </button>
    </div>
  )
}

function CategoriesInner() {
  const { loading, categories, setSearch, refresh } = useCategories()
  const navigate = useNavigate()
  const [formOpen, setFormOpen] = useState(false)
  const [editing, setEditing] = useState(null)
  const [deleting, setDeleting] = useState(null)

  const openCreate = () => {
    setEditing(null)
    setFormOpen(true)
  }

  const openEdit = (category) => {
    setEditing(category)
    setFormOpen(true)
  }

  const confirmDelete = async () => {
    const { response } = await categoriesApi.remove(deleting._id)
    if (response?.success) await refresh()
    setDeleting(null)
  }

  return (
    <div>
      <div className='tw-flex tw-items-center tw-justify-between tw-gap-3 tw-mb-2'>
        <div>
          <button
            onClick={() => navigate('/order-management')}
            className='tw-text-[12px] tw-text-gray-400'
          >
            ← Order management
          </button>
          <h2 className='font-heading tw-text-2xl'>Categories</h2>
        </div>
        <button
          onClick={openCreate}
          className='tw-rounded-[6px] tw-bg-electricGreen tw-text-white tw-text-regular tw-py-[8px] tw-px-[20px] tw-whitespace-nowrap'
        >
          + Add category
        </button>
      </div>

      <div className='tw-mb-6 tw-flex'>
        <SearchList search={(e) => setSearch(e.target.value)} />
      </div>

      {loading ? (
        <Loader />
      ) : categories.length ? (
        <div className='tw-flex tw-flex-col tw-gap-3'>
          {categories.map((category) => (
            <CategoryRow
              key={category._id}
              category={category}
              onEdit={openEdit}
              onDelete={setDeleting}
            />
          ))}
        </div>
      ) : (
        <div className='tw-text-center tw-text-gray-400 tw-py-16'>
          No categories yet
        </div>
      )}

      <Dialoguemodal
        open={formOpen}
        onClose={() => setFormOpen(false)}
        title={editing ? 'Edit category' : 'Create category'}
      >
        {formOpen && (
          <CategoryForm category={editing} onClose={() => setFormOpen(false)} />
        )}
      </Dialoguemodal>

      <ConfirmationModal
        open={!!deleting}
        onClose={() => setDeleting(null)}
        onConfirm={confirmDelete}
      >
        <div className='tw-mb-4'>
          <h3 className='tw-text-lg tw-font-semibold tw-mb-1'>Delete category</h3>
          <p className='tw-text-sm tw-text-gray-500'>
            Are you sure you want to delete “{deleting?.name}”? Products in this
            category are not deleted.
          </p>
        </div>
      </ConfirmationModal>
    </div>
  )
}

function Categories() {
  return (
    <CategoriesProvider>
      <CategoriesInner />
    </CategoriesProvider>
  )
}

export default Categories
